import React, { useEffect, useState } from "react";
import "./TermPage.css";
import api from "../../services/baseUrl";

import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import SearchBox from "../../components/Search";
import { CircularProgress } from "@mui/material";
import HighlightedText from "../../components/HighlightKeyword";
import Pagination from "../../components/Pagination";

const TermPage = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null); // Set to null initially
  const [query, setQuery] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  // const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalResults, settotalResults] = useState(0);
  useEffect(() => {
    const getDefaultTerm = async () => {
      setLoading(true);
      try {
        const response = await api.post("/terms/default");
        setData(response.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };
    getDefaultTerm();
  }, []);

  useEffect(() => {
    const sortedData = [...data];
    if (sortConfig !== null) {
      sortedData.sort((a, b) => {
        const aValue = a[sortConfig.key]?.toLowerCase?.() ?? "";
        const bValue = b[sortConfig.key]?.toLowerCase?.() ?? "";

        if (aValue < bValue)
          return sortConfig.direction === "ascending" ? -1 : 1;
        if (aValue > bValue)
          return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
      });
    }
    const endOffset = itemOffset + limit;
    const slicedData = sortedData.slice(itemOffset, endOffset);
    setCurrentItems(slicedData);
    setPageCount(Math.ceil(data.length / limit));
    settotalResults(data.length);
  }, [itemOffset, limit, data, sortConfig]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % data.length;
    setItemOffset(newOffset);

    const syariahBody = document.querySelector(".term-container");
    if (syariahBody) {
      const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
    }
    setCurrentPage(event.selected);
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getArrowIcon = (key) => {
    if (sortConfig && sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? (
        <TiArrowSortedUp size={18} className="industrial-arrow-up" />
      ) : (
        <TiArrowSortedDown size={18} className="industrial-arrow-down" />
      );
    } else {
      return <TiArrowUnsorted size={18} />;
    }
  };

  const handleSearch = async ({ searchQuery } = {}) => {
    setQuery(searchQuery);

    const payload = {
      query: searchQuery,
    };

    setLoading(true);

    try {
      const response = await api.post("/terms/search", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setData(response.data);
      } else {
        console.error("Search failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="term-container">
        <SearchBox
          onSearch={handleSearch}
          placeholder={"Enter keyword to search"}
          showPagination={true}
          defaultSearchEnable={true}
          limit={limit}
          setLimit={setLimit}
        />
        <div className="term-column-table">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 40,
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <table className="term-translation-table">
              <thead>
                <tr>
                  <th onClick={() => requestSort("english")}>
                    <div className="term-table-header">
                      Words and Phrases in English {getArrowIcon("english")}
                    </div>
                  </th>
                  <th onClick={() => requestSort("bahasa")}>
                    <div className="term-table-header">
                      Translation to Bahasa Melayu {getArrowIcon("bahasa")}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, index) => (
                  <tr key={index} style={{ height: "50px" }}>
                    <td style={{ color: "#2196f3" }}>
                      <HighlightedText
                        paragraph={item.english}
                        keyword={query}
                      />
                    </td>
                    <td>
                      <HighlightedText
                        paragraph={item.bahasa}
                        keyword={query}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <Pagination
        handlePageClick={handlePageClick}
        pageCount={pageCount}
        currentPageNumber={currentPage}
        totalResult={totalResults}
        limit={limit}
        offset={itemOffset}
      />
    </div>
  );
};

export default TermPage;
